<ng-content select="kb-header-title" />
<header>
  <div class="content">
    <ng-content select="nav[kb-site-navigation],[kb-site-navigation-loader]" />
    <nav class="logo">
      @if (logo) {
        <a [kbRouterOrExternalLink]="logo.href"><img [attr.src]="logo.src" [attr.alt]="logo.alt"></a>
      }
    </nav>
    <div class="meta-controls">
      <ng-content />
    </div>
  </div>
</header>
